module.exports = __webpack_public_path__ + "static/media/Poultrysolution.f58e49ab.jpeg";